"use client";
import { useLayoutEffect, useState } from "react";
import { useLDClient } from "@stadium/services/launch-darkly/library-imports";

export const useFeatureFlag = () => {
  const ldClient = useLDClient();
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    if (ldClient) {
      ldClient.waitUntilReady().finally(() => setIsReady(true));
    }
  }, [ldClient]);

  return { isReady };
};
